import { render } from "./DataViewer.vue?vue&type=template&id=9b93e1cc&scoped=true"
import script from "./DataViewer.vue?vue&type=script&lang=js"
export * from "./DataViewer.vue?vue&type=script&lang=js"

import "./DataViewer.vue?vue&type=style&index=0&id=9b93e1cc&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/RNAseq_web/prime_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b93e1cc"]])

export default __exports__